<div class="empty-screen-container">
  <div class="empty-screen-icon">
    <ng-icon name="unavailable"></ng-icon>
  </div>

  <div class="title">{{ title }}</div>
  <div class="description">
    {{ description }}
  </div>
</div>
